import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { Constantes } from '../../domain/constantes';
import 'rxjs/add/operator/map';
import { DomSanitizer } from '@angular/platform-browser';
import { ResponseContentType } from '@angular/http';
import { environment } from '../../../environments/environment';
import * as Q from 'q';
import { Observable } from 'rxjs/Observable';
import { Foto } from '../../domain/Foto';
import * as allSettled from 'promise-all-settled';

/*
  Generated class for the ServiciosWebServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ServiciosWebServiceProvider {

	constructor(public http: Http, private sanitizer: DomSanitizer) {
		console.log('Hello ServiciosWebServiceProvider Provider');
	}
	getLogoPath(subFolder: string): Observable<string> {
		const folderPath = `assets/layout/images/${subFolder.toLocaleUpperCase()}`;
		const headers = new Headers();
		headers.append('Content-Type', 'blob');
		headers.append('observe', 'response');
		return this.http
		  .get(`${folderPath}/ITSN.png`, { headers: headers }).map(response => {
			return folderPath + "/ITSN.png";
		  });
		  /*.pipe(
			map(response => {
			  return folderPath + "/ITSN.png";
			}),
			catchError(error => {
				return "assets/layout/images/ITSN.png";
			})
		  );*/
	  }

	/* ** Usuario ** */
	wsLogin(entidad, user, pass) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');

		const body = {
			user: user,
			pass: pass,
			entidad: entidad
		};

		return this.http.post(environment.ubimapsAPI + 'Login', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}


	wsNewToken(token) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		return this.http.get(environment.ubimapsAPI + 'NewToken', { headers: headers }).map(res => res.json());
	}

	wsNewTokenAnonimo(){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this.http.get(environment.ubimapsAPI + 'NewTokenAnonimo', { headers: headers }).map(res => res.json());
	}

	wsCrearUsuario(token, nombre, login, pass, email, idPerfil, idEspacio) {
		const headers = new Headers();

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		const body = {
            nombre: nombre,
            login: login,
            pass: pass,
			email: email,
            idPerfil: idPerfil,
            idEspacio: idEspacio,
        };

		return this.http.post(environment.ubimapsAPI + 'CrearUsuario', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	wsUpdateUsuario(token, nombre, login, pass, email, idPerfil, idEspacio, Activo) {
		const headers = new Headers();

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		const body = {
            nombre: nombre,
            login: login,
            pass: pass,
			email: email,
            idPerfil: idPerfil,
			idEspacio: idEspacio,
			activo: Activo
        };

		return this.http.post(environment.ubimapsAPI + 'UpdateUsuario', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	/* ** Ubicacion ** */
	wsObtenerUbicacion(token, latitud, longitud, balizas, ssids, idNivel) {
		const headers = new Headers();

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			Latitud: latitud,
			Longitud: longitud,
			Balizas: balizas,
			SSIDs: ssids,
			IdNivel: idNivel
		};

		return this.http.post(environment.ubimapsAPI + 'ObtenerUbicacion', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	wsObtenerXYFromLL(token, latitud, longitud, idEspacio, idAla) {
		const headers = new Headers();

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			Latitud: latitud,
			Longitud: longitud,
			IdEspacio: idEspacio,
			IdAla: idAla
		};

		return this.http.post(environment.ubimapsAPI + 'ObtenerXYFromLL', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	wsObtenerLLFromXY(token, x, y, idEspacio, idAla) {
		const headers = new Headers();

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			x: x,
			y: y,
			IdEspacio: idEspacio,
			IdAla: idAla
		};

		return this.http.post(environment.ubimapsAPI + 'ObtenerLLFromXY', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	wsBorrarRelacionTipologiaNoLocalizable(token, idContenido, idEspacio){
		// http://10.8.0.17:8888/api/DesasociarTodosUsuariosDelContenido?idContenido=b86a6fd0-74db-43f2-b1cf-798d74f76977&idEspacio=36a6c6fc-0f6f-e811-a82e-005056025d6f

		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		return this.http.get(environment.ubimapsAPI + 'DesasociarTodosUsuariosDelContenido' + '?idContenido=' + idContenido + '&idEspacio=' + idEspacio, { headers: headers }).map(res => res.json());

	}
	ObtenerFavoritos(token,idEspacio){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		return this.http.get(environment.ubimapsAPI + 'ObtenerFavoritos' + '?idEspacio=' + idEspacio, { headers: headers }).map(res => res.json());
	}

	/* ** Calculo Ruta ** */
	wsCalcularRuta(token, idEspacio, idNodoOrigen, idNodoDestino, idPerfilMovilidad) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			idEspacio: idEspacio,
			idNodoOrigen: idNodoOrigen,
			idNodoDestino: idNodoDestino,
			idPerfilMovilidad: idPerfilMovilidad
		};

		return this.http.post(environment.ubimapsAPI + 'CalcularRuta', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	/* ** Envio Push ** */
	wsEnviarPush(token: string, idEntidad: string, idEspacio: string, idAviso: string, idContenido: string, users: string[], salas: string[], titulo: string, msg: string, cuerpo: string, imagen: string, criteriosEnvio: any[]) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			guidEntidad: idEntidad,
			guidContenido: idContenido,
			guidAvisoCiudadano: idAviso,
			cuerpo: cuerpo,
			imagen: imagen,
			espacio: idEspacio,
			secciones: salas,
			users: users,
			titulo: titulo,
			msg: msg,
			criteriosEnvio: criteriosEnvio
		};

		return this.http.post(environment.ubimapsAPI + 'EnviarPush', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	wsGetEstimacionDestinatarios(token: string, idEntidad: string, idEspacio: string, users: string[], salas: string[], titulo: string, msg: string, criteriosEnvio: any[]) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			guidEntidad: idEntidad,
			espacio: idEspacio,
			secciones: salas,
			users: users,
			titulo: titulo,
			msg: msg,
			criteriosEnvio: criteriosEnvio
		};

		return this.http.post(environment.ubimapsAPI + 'GetEstimacionDestinatarios', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	/* ** GEOCALIBRACION_ALA ** */
	wsGetGeocalibracionAlasEspacio(token: string, idEspacio: string) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		return this.http.get(environment.ubimapsAPI + 'obtenerGeocalibracionAlasEspacio' + '?idEspacio=' + idEspacio, { headers: headers }).map(res => res.json());

	}

	/* ** Recordar Password ** */
	wsRecordarPassword (entidad: string, user: string) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const body = {
			entidad: entidad,
			login: user
		};

		return this.http.post(environment.ubimapsAPI + 'RecordarPassword', JSON.stringify(body), { headers: headers })
		.map(res =>
			res.json()
		);
	}

	wsConfirmarPassword(token: string, entidad: string, user: string, newPass: string, newPassConfirm: string)
	{
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			entidad: entidad,
			login: user,
			newPassword: newPass,
			newPassConfirm: newPassConfirm
		};

		return this.http.post(environment.ubimapsAPI + 'ConfirmarPassword', JSON.stringify(body), { headers: headers })
		.map(res =>
			res.json()
		);
	}

	/* ** Migrar BBDD ** */
	wsMigrarBD(token, idEntidad?) {

		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		if (!idEntidad) {
			return this.http.get(environment.ubimapsDiagnostico + 'MigrarBD', { headers: headers }).map(res => res.json());
		}
		else{
			return this.http.get(environment.ubimapsDiagnostico + 'MigrarBD' + '?idEntidad=' + idEntidad, { headers: headers }).map(res => res.json());
		}
	}

	wsMigrarBBDD(){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		return this.http.get(environment.ubimapsDiagnostico + 'MigrarBBDD', { headers: headers }).map(res => res.json());
	}

	RepararIdiomas(token, idEntidad?){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		if (idEntidad) {
			return this.http.get(environment.ubimapsDiagnostico + 'RepararIdiomas' , { headers: headers }).map(res => res.json());
		}
	}

	/* ** Buscar Contenidos ** */
	wsValidarIdAlternativoContenidos(token: string, idEspacio, idAlternativo){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		return this.http.get(environment.ubimapsAPI + 'ValidarIdAlternativoContenidos' + '?idEspacio=' + idEspacio + '&idAlternativo=' + idAlternativo, { headers: headers }).map(res => res.json());
	}

	wsBuscarContenidos(token: string, idEspacio, idIdioma, Titulo, Estado, Desde, Hasta, Codigo, Tipologia, AsignadoA, first, size, orderBy, order, excluidos, activos)
	{
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			idIdioma: idIdioma,
			idEspacio: idEspacio,
			Titulo: Titulo,
			Estado: Estado,
			Desde: Desde,
			Hasta: Hasta,
			Codigo: Codigo,
			Tipologia: Tipologia,
			AsignadoA: AsignadoA,
			Excluidos: excluidos,
			Activos: activos,
			filtro: {
				first: first, // 0
				size: size, // 10
				orderBy: orderBy,
				order: order // 'DESC'
			}
		};

		return this.http.post(environment.ubimapsAPI + 'BuscarContenidos', JSON.stringify(body), { headers: headers })
		.map(res =>
			res.json()
		);
	}

	wsBuscarContenidosExportar(token: string, idEspacio, idIdioma, Titulo, Estado, Desde, Hasta, Codigo, Tipologia, AsignadoA, first, size, orderBy, order, excluidos)
	{
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			idIdioma: idIdioma,
			idEspacio: idEspacio,
			Titulo: Titulo,
			Estado: Estado,
			Desde: Desde,
			Hasta: Hasta,
			Codigo: Codigo,
			Tipologia: Tipologia,
			AsignadoA: AsignadoA,
			Excluidos: excluidos,
			filtro: {
				first: first, // 0
				size: size, // 10
				orderBy: orderBy,
				order: order // 'DESC'
			}
		};

		return this.http.post(environment.ubimapsAPI + 'BuscarContenidosExportar', JSON.stringify(body), { headers: headers })
		.map(res =>
			res.json()
		);
	}


	wsObtenerUrlDescargaEverpaths(idEntidad: any, idQR: any) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this.http.get(environment.ubimapsAPI + 'ObtenerUrlDescargaEverpaths' + '?idEntidad=' + idEntidad + '&idQR=' + idQR, { headers: headers }).map(res => res.json());
	}

	wsObtenerRespuestas(token: string, idEspacio, idIdioma){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		return this.http.get(environment.ubimapsAPI + 'ObtenerRespuestas' + '?idEspacio=' + idEspacio + '&idIdioma=' + idIdioma, { headers: headers }).map(res => res.json());
	}

	wsObtenerQRInfoVisorAR(idEntidad: any, idQR: any) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this.http.get(environment.ubimapsAPI + 'ObtenerQRInfoVisorAR' + '?idEntidad=' + idEntidad + '&idQR=' + idQR, { headers: headers }).map(res => res.json());
	}

	wsObtenerContenidoVisorExterno(idEntidad: any, idContenido: any): any {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');

		console.log(environment.ubimapsAPI + 'ObtenerContenidoVisorExterno' + '?idEntidad=' + idEntidad + '&idContenido=' + idContenido);
		return this.http.get(environment.ubimapsAPI + 'ObtenerContenidoVisorExterno' + '?idEntidad=' + idEntidad + '&idContenido=' + idContenido, { headers: headers })
		.map(res =>
			res.json()
		);
	}

	wsObtenerMetasContenidoVisorExterno(idEntidad: any, idContenido: any): any {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');

		console.log(environment.ubimapsAPI + 'ObtenerMetasContenidoVisorExterno' + '?idEntidad=' + idEntidad + '&idContenido=' + idContenido);
		return this.http.get(environment.ubimapsAPI + 'ObtenerMetasContenidoVisorExterno' + '?idEntidad=' + idEntidad + '&idContenido=' + idContenido, { headers: headers })
		.map(res =>
			res.json()
		);
	}

	/* ** Informacion Espacio ** */
	wsGetTramosCortados(token: string, idEspacio){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		return this.http.get(environment.ubimapsAPI + 'getTramosCortados' + '?idEspacio=' + idEspacio, { headers: headers }).map(res => res.json());

	}
/*
	getBeaconsEspacio(token: string, nivelBateria: number, idEspacio){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		return this.http.get(environment.ubimapsAPI + 'getBeaconsEspacio' + '?idEspacio=' + idEspacio, { headers: headers }).map(res => res.json());
	}
*/

	/* ** Subida FOTO ** */
	wsSubidaFoto(token, entidad, idContenido, fichero, nombreArchivo, idFoto = null) {
		const headers = new Headers();
		// headers.append('Content-Type', fichero.type);
		headers.append('Authorization', 'Bearer ' + token);

		const formData: FormData = new FormData();
		formData.append('Content-Type', fichero.type);
		if (idFoto){
			formData.append('idFoto', idFoto);
		}
		formData.append(entidad, idContenido);
		formData.append('data', fichero, nombreArchivo);

		return this.http.post(environment.ubimapsAPI + 'Upload', formData, { headers: headers })
		.map( function(res){

			return res.json();

		});
	}

	wsActualizarFotoConDetalle(token, entidad, idContenido, fichero, nombreArchivo, idFoto){
		// UpdateFotoWithFotoDetalle
		const headers = new Headers();
		// headers.append('Content-Type', fichero.type);
		headers.append('Authorization', 'Bearer ' + token);

		const formData: FormData = new FormData();
		formData.append('Content-Type', fichero.type);
		formData.append(entidad, idContenido);
		formData.append('idFoto', idFoto);
		formData.append('data', fichero, nombreArchivo);

		return this.http.post(environment.ubimapsAPI + 'UpdateFotoWithFotoDetalle', formData, { headers: headers })
		.map( function(res){

			return res.json();

		});
	}

	wsActualizarFotosCarrusel(token, idContenido, fotos: Foto[], nombreArchivo){
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);


		const body = {
			idContenido: idContenido,
			FotosCarrusel: fotos.map( (f) =>  {
				return {
					idContenido: f.IdContenido,
					idFoto: f.Id,
					UrlFotoExt: f.UrlFotoExt,
					UrlFotoExt_detalle: f.UrlFotoExt_detalle,
					IdFotoExt: f.IdFotoExt,
					IdFotoExt_detalle: f.IdFotoExt_detalle,
					Tipo: f.Tipo,
					Orden: f.Orden,
				}
			})
		};

		return this.http.post(environment.ubimapsAPI + 'UpdateFotosCarrusel', JSON.stringify(body), { headers: headers })
		.map( function(res){

			return res.json();

		});
	}

	wsBorrarFotoConDetalle(token, entidad, idContenido, fichero, nombreArchivo){
		console.log("servicios web para");
		const headers = new Headers();
		headers.append('Authorization', 'Bearer ' + token);
		return this.http.get(environment.ubimapsAPI + 'DeleteFotoDetalle' + '?idContenido=' + idContenido, { headers: headers }).map(res => res.json());

	}

	/* ** Subida FICHERO a CMS ** */
	public subirFicheroCMS(fichero, that?, user = environment.CMS_user_1, token = environment.CMS_token){
		that = that !== undefined ? that : this;

		console.log('subirFicheroCMS  fichero = ' + fichero);
		const headers = new Headers();
		headers.append('Accept', 'application/json');

		if ( user + '' !== '' ) {
			headers.append('Bearer',  token);
			headers.append('Access-Control-Allow-Origin', '*');
		}

		const formData: FormData = new FormData();
		formData.append('data', fichero);

		return that.http.post(environment.urlCMS, formData, { headers: headers })
		.map(res => {
			const resp = res.json();

			console.log('RESPUESTA = ' + JSON.stringify(resp));
			// return Constantes.urlCMS + '/' + resp.docs[0].id;

			if (!resp.docs[0].externalURL) {
				return environment.urlCMS + '/' + resp.docs[0].id;
			}
			else{
				return resp.docs[0].externalURL;
			}
		});
	}

	public subirFotosCMS(ficheroList: Foto[], user = environment.CMS_user_1, token = environment.CMS_token): Promise<Foto[]>{
		const fotosResp = [];
		if (ficheroList && ficheroList.length > 0) {
			return this.subidaFicherosCMS(ficheroList, undefined, user, token)
			.then(function(respuestas) {
				console.log(respuestas);
				respuestas.forEach(element => {
					const resp = element.json();
					console.log('RESPUESTA = ' + JSON.stringify(resp));
					const fotoAux = new Foto();

					let UUID = null;
					if(resp.docs[0].id){
						UUID = resp.docs[0].id;
						let matches = resp.docs[0].id.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g);
						if (matches && matches.length > 0) {
							UUID = matches[0];
						}
					}

					if (!resp.docs[0].externalURL) {
						fotoAux.IdFotoExt = UUID;
						fotoAux.UrlFotoExt = environment.urlCMS + '/' + resp.docs[0].id;
					}
					else{
						fotoAux.IdFotoExt = UUID;
						fotoAux.UrlFotoExt = resp.docs[0].externalURL;
					}

					fotosResp.push(fotoAux);
				});
				return fotosResp;
			});
		}
		else {
			return Promise.resolve(fotosResp);
		}
	}

	subirFicherosFromHTML(html){
		const files = this.filesFromHTML(html);
		return this.subidaFicherosCMS(files)
		.then(function (urls) {
			console.log('FICHEROS SUBIDOS: ');
			console.log(urls);
			return urls;
		})
		.catch(function (error) {
			console.error('FICHEROS SUBIDOS ERROR: ' + error);
		});
	}

	private subidaFicherosCMS(ficheroList, that?, user = environment.CMS_user_1, token = environment.CMS_token){
		that = that !== undefined ? that : this;

		const promises: any[] = [];

		ficheroList.forEach(fichero => {
			const headers = new Headers();
			headers.append('Accept', 'application/json');

			if ( user + '' !== '' ) {
				headers.append('Bearer',  token);
				headers.append('Access-Control-Allow-Origin', '*');
			}

			const formData: FormData = new FormData();
			formData.append('data', fichero);
			promises.push(that.http.post(environment.urlCMS, formData, { headers: headers }).toPromise());
		});
		return Promise.all(promises);
	}

	/* ** Subida Base64 a CMS ** */
	public subirBase64CMS(Base64, nombreArchivo, type) {
		// const blob: Blob = this.dataURItoBlob(Base64, type);
		// this.blobToFile(blob, nombreArchivo + '.' + type);
		const file: File = this.base64ToFileSync(Base64, nombreArchivo, type);
		return this.subirFicheroCMS(file);
	}


/* ** Gestion Imagen ** */

	getImgBase64FromHTML(html: string){
		const regex = /<img[^>]+src="data:image\/(.*?);base64,(.*?)"[^\>]*>/g;
		let m;
		const b64s = [];
		while ( m = regex.exec( html ) ) {
			const b64 =  m[2] ;
			b64s.push(b64);
		}
		return b64s;
	}

	getImgSrcFromHTML(html: string){
		const regex = /<img[^>]+src="data:image\/(.*?);base64,(.*?)"[^\>]*>/g;
		let m;
		const srcs = [];
		while ( m = regex.exec( html ) ) {
			const src =  'data:image/' + m[1] + ';base64,' + m[2] ;
			srcs.push(src);
		}
		return srcs;
	}

	// HTML a Files
	filesFromHTML(html: string): File[]{
		// https://www.regextester.com/103676
		const regex = /<img[^>]+src="data:image\/(.*?);base64,(.*?)"[^\>]*>/g;
		let m;
		const urls = [];
		const tipos = [];
		const files: File[] = [];
		while ( m = regex.exec( html ) ) {
			const tipo = 'image/' + m[1];
			const b64 =  m[2] ;
			const nombreArchivo = Math.floor(Date.now() / 1000) + '';
			const file: File = this.base64ToFileSync(b64, nombreArchivo, tipo);
			files.push(file);
		}
		return files;
	}


	// Fichero a Base64
	imageTobase64(file) {
		const that = this;
		let src = window.URL.createObjectURL(file);
		// Create a FileReader
		const reader = new FileReader();
		// Add an event listener to deal with the file when the reader is complete
		reader.addEventListener('load', (event: any) => {
			// Get the event.target.result from the reader (base64 of the image)
			src = event.target.result;
			// Push the img src (base64 string) into our array that we display in our html template
			// that.uploadedFilesAla.push(src);
			this.onBase64Generated(src);
		}, false);

		return reader.readAsDataURL(file);
	}
	onBase64Generated(img) {
		console.warn('Implementar: onBase64Generated');
	}

	// Base64 a Fichero
	base64ToFile(base64, nombre, mimeType?){
		const url = base64;
		return fetch(url)
		.then(res => res.blob())
		.then(blob => {
			if (!mimeType) {
				// mimeType = 'image/jpeg';
				mimeType = blob.type;
			}
			const file: any = new File([blob], nombre, {type: mimeType});

			return file;
		});
	}

	base64ToFileSync(base64, nombre, mimeType?){
		const blob: Blob = this.dataURItoBlob(base64, mimeType);
		const file: File = this.blobToFile(blob, nombre + '.' + mimeType);
		return file;
	}

	// Base64 a Blob
	dataURItoBlob(base64, mimeString) {
		// convert base64/URLEncoded data component to raw binary data held in a string
		const byteString = atob(base64);
		// write the bytes of the string to a typed array
		const ia = new Uint8Array(byteString.length);
		for (let i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ia], {type: mimeString});
	}

	// Blob a Fichero
	blobToFile = (theBlob: Blob, fileName: string): File => {
		const b: any = theBlob;
		// A Blob() is almost a File() - it's just missing the two properties below which we will add
		b.lastModifiedDate = new Date();
		b.name = fileName;
		// Cast to a File() type
		return <File>theBlob;
	}

	/* ** DESCARGA FICHERO LOCAL ** */
	downloadFile(urlBase, fileName) {
		return this.http
		.get(urlBase, {
		responseType: ResponseContentType.Blob // ,
		// search: // query string if have
		})
		.map(res => {
		return {
			filename: fileName,
			data: res.blob()
		};
		})
		.subscribe(res => {
			console.log('start download:', res);
			const url = window.URL.createObjectURL(res.data);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.setAttribute('style', 'display: none');
			a.href = url;
			a.download = res.filename;
			a.click();
			window.URL.revokeObjectURL(url);
			a.remove(); // remove the element
		}, error => {
			console.log('download error:', JSON.stringify(error));
		}, () => {
			console.log('Completed file download.');
		});
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/web-service-service/servicios-web-service.ts